import { getStore } from '../store/store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import {
    isAccountExplicitLogon,
    isMailboxSharedOrDelegate,
} from 'owa-account-shared-mailbox-utils';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function isTabbedSearchEnabled(isFromQfScopeTabs: boolean): boolean {
    // Deprecate SERP tabs if the feature flag is enabled, but still allow QFScope tabs
    if (isGlobalFeatureEnabled('sea-deprecateSerpTabs') && !isFromQfScopeTabs) {
        return false;
    }

    const mailboxInfo = getModuleContextMailboxInfo();

    // Suppress SERP tabs if the store flag is set and the check is not from QF scope tabs
    if (getStore().shouldSuppressTabs && !isFromQfScopeTabs) {
        return false;
    }
    // If shared mailbox as resource, as account, or explicit logon/delegate access, disable tabbed search
    if (isMailboxSharedOrDelegate(mailboxInfo) || isAccountExplicitLogon(mailboxInfo)) {
        return false;
    }

    return true;
}
